export default __webpack_public_path__ + "static/media/fa-regular-400.86ce7813.eot";